import type { SupportedLocale } from 'i18n/util/locale'

export interface LanguageOption {
  locale: SupportedLocale
  /** Two-letter language code for the query param and cookie */
  langCode: string
  /** Country code for the Flag component */
  flagCode: string
  /** Language name in its native language */
  nativeName: string
}

export const LANGUAGE_OPTIONS: Array<LanguageOption> = [
  { locale: 'en-AU', langCode: 'en', flagCode: 'AU', nativeName: 'English' },
  { locale: 'fr-FR', langCode: 'fr', flagCode: 'FR', nativeName: 'Français' },
  { locale: 'de-DE', langCode: 'de', flagCode: 'DE', nativeName: 'Deutsch' },
]

export const LANG_CODE_TO_LOCALE: Record<string, SupportedLocale> = {
  en: 'en-AU',
  fr: 'fr-FR',
  de: 'de-DE',
}
